import { LoadingScreen, NotFound } from 'views';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useEffect, useMemo } from 'react';
import Layout from 'containers/Layout';
import MaybeRedirectGeo from 'containers/MaybeRedirectGeo';
import { Route } from 'react-router';
import { getSsoLoginOptions } from 'utils/auth/ssoPreference';
import { isSpateUser } from 'utils/helpers';
import { mixpanelTrack } from 'utils/app';

const withLayout = (Component) =>
    function (props) {
        return (
            <MaybeRedirectGeo>
                <Layout>
                    <Component {...props} />
                </Layout>
            </MaybeRedirectGeo>
        );
    };

const withForceAdmin = (Component) =>
    function (props) {
        const { user } = useAuth0();
        const isAdmin = isSpateUser({ email: user?.email });
        if (!isAdmin) return <NotFound />;
        return <Component {...props} />;
    };

function Redirecting() {
    useEffect(() => {
        mixpanelTrack('Redirecting');
    }, []);

    return <LoadingScreen />;
}

function AuthRoute({ component, forceAdmin = false, ...rest }) {
    const Component = useMemo(
        () =>
            withAuthenticationRequired(
                withLayout(forceAdmin ? withForceAdmin(component) : component),
                {
                    onRedirecting: () => <Redirecting />,
                    loginOptions: getSsoLoginOptions(),
                },
            ),
        [component, forceAdmin],
    );

    return <Route {...rest} render={(props) => <Component {...props} />} />;
}

export default AuthRoute;
